/*
  Subcollection pills.

  Desktop keeps the toolbar on a single row: as many pills as the free track can
  hold are shown, the rest fold behind a "+N" button. How many fit is measured
  from the real track width, so a 1024px laptop shows fewer pills than a 1920px
  screen instead of overflowing under the filter button. Pressing "+N" reveals
  the remainder, which wrap onto the following lines.

  Below the 750px breakpoint the row scrolls horizontally instead and every pill
  stays visible, so the measuring is skipped entirely.
*/
(() => {
  const BREAKPOINT = 750;
  const GAP = 8;
  const HIDDEN = 'collection-header__pill--hidden';

  /*
    The button's wording comes from the theme translations: Liquid hands over the
    localised string with an __N__ placeholder so the count can be swapped in
    without hardcoding anything here.
  */
  const label = (button, count) =>
    (button.dataset.labelTemplate || '+__N__').replace('__N__', count);

  const pillsOf = (nav) =>
    Array.from(nav.querySelectorAll('.collection-header__pill')).filter(
      (el) => !el.classList.contains('collection-header__pills-more')
    );

  function measure(nav) {
    const pills = pillsOf(nav);
    const more = nav.querySelector('.collection-header__pills-more');
    if (!pills.length) return;

    // Once the reader has opened the list we leave it open.
    if (nav.dataset.expanded === 'true') {
      pills.forEach((pill) => pill.classList.remove(HIDDEN));
      if (more) more.hidden = true;
      nav.dataset.measured = 'true';
      return;
    }

    // Reset so every pill reports its natural width.
    pills.forEach((pill) => pill.classList.remove(HIDDEN));
    if (more) more.hidden = true;
    nav.dataset.measured = 'true';

    if (window.innerWidth < BREAKPOINT || !more) return;

    const style = getComputedStyle(nav);
    const available =
      nav.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);

    const widths = pills.map((pill) => pill.getBoundingClientRect().width);
    const total = widths.reduce((sum, w) => sum + w, 0) + GAP * (pills.length - 1);
    if (total <= available) return;

    // Reserve the button, sized against its widest possible label.
    more.hidden = false;
    more.textContent = label(more, pills.length);
    let used = more.getBoundingClientRect().width;

    let shown = 0;
    for (let i = 0; i < pills.length; i += 1) {
      const next = used + GAP + widths[i];
      if (next > available) break;
      used = next;
      shown += 1;
    }
    shown = Math.max(shown, 1);

    pills.forEach((pill, i) => pill.classList.toggle(HIDDEN, i >= shown));
    more.textContent = label(more, pills.length - shown);
  }

  function measureAll() {
    document.querySelectorAll('.collection-header__pills').forEach(measure);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.collection-header__pills-more');
    if (!button) return;

    const nav = button.closest('.collection-header__pills');
    if (!nav) return;

    nav.dataset.expanded = 'true';
    button.setAttribute('aria-expanded', 'true');
    pillsOf(nav).forEach((pill) => pill.classList.remove(HIDDEN));
    button.hidden = true;

    const firstRevealed = nav.querySelector('.collection-header__pill--overflow');
    if (firstRevealed) firstRevealed.focus({ preventScroll: true });
  });

  let frame = null;
  const schedule = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(measureAll);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureAll, { once: true });
  } else {
    measureAll();
  }

  // Web fonts land after first paint and change every pill's width.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();
